module.exports = __webpack_public_path__ + "img/active.3626e36b.png";